import React from 'react'

export const WriteAnotherReviewCta: React.FC = () => {
  return (
    <div id='review-cta-container-page-2' className='media-object'>
      <div className='media-object-icon-container'>
        <div className='media-object-icon'>
          <i className='fal fa-pen-square fa-3x' />
        </div>
      </div>
      <div className='media-object-content'>
        <div className='vanilla-auto'>
          <h4>Write another review</h4>
          <div>
            Sharing more of your first-hand experiences helps your procurement colleagues make smart purchasing decisions.
          </div>
        </div>
        <div className='button-container'>
          <a href='/reviews/new' className='button'>START ANOTHER REVIEW</a>
        </div>
      </div>
    </div>
  )
}
